import script from "./BaseFormEnr.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFormEnr.vue?vue&type=script&setup=true&lang=js"

import "./BaseFormEnr.vue?vue&type=style&index=0&id=21d71474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d71474"]])

export default __exports__